import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed } from 'vue'

/**
 * How many of this diner's orders are still in play.
 *
 * Held on the device rather than fetched per page. The badge appears on every
 * screen, and a request on every navigation to render a number that changes a
 * handful of times a day is a poor trade — so it is written whenever we are
 * already talking to the server about orders (the You screen loading them, a
 * placement, a status poll reaching a terminal state) and read everywhere else.
 *
 * The cost is honest and bounded: sitting on a menu page while the kitchen
 * marks an order ready leaves the badge one behind until the next fetch. It is
 * a count, not the order itself, and the order's own screen is always live.
 */
export const useLiveOrdersStore = defineStore('pjazza-live-orders', () => {
  const stored = useLocalStorage<number>('twn-pjazza-live-orders', 0)

  const count = computed(() => Math.max(0, stored.value))

  const set = (next: number): void => {
    stored.value = Math.max(0, next)
  }

  const increment = (): void => {
    stored.value = count.value + 1
  }

  const clear = (): void => {
    stored.value = 0
  }

  return { count, set, increment, clear }
})
